import React from 'react'

const PrimaryFooter = () => {
  return (
    <div className='bg-gray-100 bg-opacity-95 flex flex-col justify-center items-center w-full px-10 py-4'>
      <ul className='flex flex-row gap-x-5 gap-y-5 items-center mb-8'>
        <li className='flex flex-col items-center'>
          <i className='text-2xl fab fa-facebook-f scale-125 hover:scale-150 transition-all duration-500'></i>
        </li>
        <li className='flex flex-col items-center'>
          <i className='text-2xl 	fab fa-twitter scale-125 hover:scale-150 transition-all duration-500'></i>
        </li>
        <li className='flex flex-col items-center'>
          <i className='text-2xl fa fa-instagram scale-125 hover:scale-150 transition-all duration-500'></i>
        </li>
      </ul>
      <h3 className='mx-2 text-center text-blue-600 text-xl font-medium'>
        © Copyright 2020. WirelessStore.com LLC
      </h3>
    </div>
  )
}

export default PrimaryFooter
